import BaseService from './BaseService'

export async function apiSignUp(data) {
    const res = await BaseService.post('/sign-up', data)
    return res.data
}

export async function apiLogin(data) {
    const res = await BaseService.post('/auth/login', data)
    return res.data
}

export async function apiRefreshToken(data) {
    const res = await BaseService.post('/auth/refresh', data, {
        skipAuthRefresh: true,
    })
    return res.data
}

export async function apiGetMe() {
    const res = await BaseService.get('/auth/me')
    return res.data
}

export async function apiSignOut(data) {
    const res = await BaseService.post('/auth/logout', data)
    return res.data
}

export async function apiSignOutAll() {
    const res = await BaseService.post('/auth/logout-all')
    return res.data
}
